import { render, staticRenderFns } from "./ProfileActionSend.vue?vue&type=template&id=85c6fe08&"
import script from "./ProfileActionSend.vue?vue&type=script&lang=js&"
export * from "./ProfileActionSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports